var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkCircle28 = function SvgQuestionMarkCircle28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.917 11.082a4.088 4.088 0 0 1 4.084-4.083 4.088 4.088 0 0 1 4.083 4.083c0 1.843-1.237 3.387-2.917 3.893v1.357a1.166 1.166 0 1 1-2.333 0v-2.333c0-.646.521-1.167 1.167-1.167.965 0 1.75-.785 1.75-1.75s-.785-1.75-1.75-1.75-1.75.785-1.75 1.75a1.166 1.166 0 1 1-2.334 0Zm2.917 8.75a1.166 1.166 0 1 1 2.333 0 1.166 1.166 0 1 1-2.333 0Zm1.167 3.5c-5.147 0-9.334-4.187-9.334-9.333s4.187-9.334 9.334-9.334c5.146 0 9.333 4.188 9.333 9.334s-4.187 9.333-9.333 9.333Zm0-21c-6.433 0-11.667 5.234-11.667 11.667s5.234 11.666 11.667 11.666S25.667 20.432 25.667 14c0-6.433-5.233-11.667-11.666-11.667Z",
    fill: "#008545"
  })));
};
export default SvgQuestionMarkCircle28;